import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../../utils/api';
import { errorText } from '../../utils/errorText';
import AiIdentifyPanel from '../AiIdentifyPanel';

/*
 * "Identify with AI" for one of my own event finds, by its photographs
 * (POST /ai/identify {photo_ids}). A guest of the event may ask only this way,
 * only while the event is in play, within its allowance (routes/ai.py, Part
 * III rule 6); staff the same. The answer is linked to the find at once, so
 * the card takes it; "Use this name" links it with that name. The panel's
 * danger warnings and its refusal of a dangerous look-alike are unchanged,
 * and a standing notice says never to eat or taste wild mushrooms.
 */
export default function EventFindAi({ card, onLinked }) {
  const { t } = useTranslation('events');
  const [open, setOpen] = useState(false);
  const [aiId, setAiId] = useState(null);
  const [message, setMessage] = useState('');
  if (!card?.photo_ids?.length) return null;

  const link = async (id, accept) => {
    try {
      await api.post(`/ai/identifications/${id}/link`, { sample_id: card.sample_id, ...(accept ? { accept } : {}) });
      setMessage(accept ? t('ai.named', { name: accept.taxon_name }) : t('ai.linked'));
      onLinked?.();
    } catch (e) {
      setMessage(errorText(e));
    }
  };

  if (!open) {
    return (
      <button type="button" className="pn-btn-ghost" style={{ minHeight: 40, marginTop: 6 }}
        onClick={() => setOpen(true)} data-testid="event-find-ai-open">
        {t('ai.open')}
      </button>
    );
  }
  return (
    <div data-testid="event-find-ai" style={{ marginTop: 8 }}>
      <p role="note" style={{ fontSize: 13, background: '#fff3e0', color: '#5d4037', padding: '6px 8px',
        borderRadius: 8 }}>{t('safety.neverEat')}</p>
      <AiIdentifyPanel photoIds={card.photo_ids} autoRun pickAny compact
        onResult={(r) => { if (r?.ai_id) { setAiId(r.ai_id); link(r.ai_id, null); } }}
        onAccept={(candidate) => aiId && link(aiId, { taxon_name: candidate.taxon_name,
          rank: ['species', 'genus', 'family'].includes(candidate.rank) ? candidate.rank : 'species' })} />
      {message && <p role="status" data-testid="event-find-ai-status">{message}</p>}
    </div>
  );
}
